const headerPalette = {
  header: {
    background: '#E9ECEE',
  },
};

export default headerPalette;
